/**
 * Os 28 modelos aprovados, como TOKENS (não HTML fixo).
 * Assim o mesmo componente renderiza qualquer modelo, e as cores do cliente
 * (extraídas da logo ou escolhidas a mão) entram por cima como override.
 */

export const TEMPLATES = [
  {
    id: 'aurora', nome: 'Aurora Glass', nicho: 'Universal · moderno',
    t: {
      bg: 'linear-gradient(160deg,#6a5bff 0%,#b14be0 55%,#ff6b9d 100%)',
      ink: '#ffffff', sub: 'rgba(255,255,255,.78)',
      accent: '#ffffff', onAccent: '#4a2bd0',
      card: 'rgba(255,255,255,.18)', cardBorder: '1px solid rgba(255,255,255,.32)',
      chip: 'rgba(255,255,255,.2)', chipBorder: '1px solid rgba(255,255,255,.28)',
      avatarBg: 'rgba(255,255,255,.22)', avatarInk: '#ffffff', avatarBorder: '2px solid rgba(255,255,255,.5)',
      dock: 'rgba(60,30,120,.55)', dockBorder: '1px solid rgba(255,255,255,.18)',
      font: "'Outfit',Inter,sans-serif", headFont: "'Outfit',Inter,sans-serif",
      radius: '16px', avatarRadius: '50%', glass: true,
    },
  },
  {
    id: 'grafite', nome: 'Grafite & Ouro', nicho: 'Joalheria · advocacia · estética',
    t: {
      bg: '#111114', glow: 'radial-gradient(120% 90% at 50% 0,rgba(201,162,75,.35),transparent 70%)',
      ink: '#f5f1e6', sub: 'rgba(245,241,230,.7)',
      accent: '#c9a24b', onAccent: '#111114',
      card: '#1b1b20', cardBorder: '1px solid #33333d',
      chip: '#1b1b20', chipBorder: '1px solid #33333d',
      avatarBg: 'linear-gradient(140deg,#c9a24b,#f0d996)', avatarInk: '#111114',
      dock: 'rgba(17,17,20,.9)', dockBorder: '1px solid #2a2a33',
      font: 'Inter,sans-serif', headFont: "'Playfair Display',Georgia,serif",
      radius: '16px', avatarRadius: '50%',
    },
  },
  {
    id: 'terra', nome: 'Terra Quente', nicho: 'Padaria · café · restaurante',
    t: {
      bg: '#faf3e9', ink: '#3b2a1e', sub: '#8a6a52',
      accent: '#b4552f', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #e6d8c6',
      chip: '#ffffff', chipBorder: '1px solid #e6d8c6',
      avatarBg: '#ffffff', avatarInk: '#b4552f', avatarBorder: '4px solid #faf3e9',
      dock: 'rgba(250,243,233,.94)', dockBorder: '1px solid #e6d8c6',
      font: 'Inter,sans-serif', headFont: "'Fraunces',Georgia,serif",
      radius: '16px', avatarRadius: '50%', capaTopo: true,
    },
  },
  {
    id: 'clean', nome: 'Clean Google', nicho: 'Universal · serviços',
    t: {
      bg: '#ffffff', ink: '#1f2328', sub: '#5f6368',
      accent: '#1a73e8', onAccent: '#ffffff',
      card: '#f8f9fa', cardBorder: '1px solid #e8eaed',
      chip: '#f1f3f4', chipBorder: '1px solid #f1f3f4',
      avatarBg: '#e8f0fe', avatarInk: '#1a73e8',
      dock: 'rgba(255,255,255,.95)', dockBorder: '1px solid #e8eaed',
      font: 'Inter,sans-serif', headFont: 'Inter,sans-serif',
      radius: '16px', avatarRadius: '50%',
    },
  },
  {
    id: 'neon', nome: 'Neon Tech', nicho: 'Assistência · tech · games',
    t: {
      bg: '#070b18', grade: true,
      glow: 'radial-gradient(70% 40% at 50% 0,rgba(47,180,255,.28),transparent 65%)',
      ink: '#e8f0ff', sub: 'rgba(232,240,255,.72)',
      accent: '#2fb4ff', accent2: '#22e0c8', onAccent: '#04121f',
      card: '#0d1730', cardBorder: '1px solid #1e3a6e',
      chip: '#0d1730', chipBorder: '1px solid #1e3a6e', chipInk: '#9fd4ff',
      avatarBg: '#0d1730', avatarInk: '#2fb4ff', avatarBorder: '2px solid #2fb4ff',
      avatarGlow: '0 0 26px rgba(47,180,255,.55)',
      dock: 'rgba(7,11,24,.92)', dockBorder: '1px solid #1e3a6e',
      font: "'Space Grotesk',Inter,sans-serif", headFont: "'Space Grotesk',Inter,sans-serif",
      radius: '16px', avatarRadius: '50%',
    },
  },
  {
    id: 'wellness', nome: 'Pastel Wellness', nicho: 'Salão · estética · spa',
    t: {
      bg: 'linear-gradient(180deg,#fdf1f5 0%,#f6f0fb 60%,#ffffff 100%)',
      ink: '#3f2d3d', sub: '#a2789a',
      accent: '#e0729b', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #f0dbe6',
      chip: '#ffffff', chipBorder: '1px solid #f0dbe6', chipInk: '#7a5c72',
      avatarBg: 'linear-gradient(140deg,#f3b8cd,#c9a7e8)', avatarInk: '#ffffff',
      dock: 'rgba(255,255,255,.94)', dockBorder: '1px solid #f0dbe6',
      font: "'Outfit',Inter,sans-serif", headFont: "'Outfit',Inter,sans-serif",
      radius: '16px', avatarRadius: '50%', sombraBtn: true,
    },
  },
  {
    id: 'urgencia', nome: 'Bloco Urgência', nicho: 'Chaveiro · desentupidora · guincho',
    t: {
      bg: '#111111', ink: '#ffffff', sub: 'rgba(255,255,255,.72)',
      accent: '#ffd400', onAccent: '#111111',
      card: '#1c1c1c', cardBorder: '1px solid #333333',
      chip: '#1c1c1c', chipBorder: '1px solid #333333', chipInk: '#ffd400',
      avatarBg: '#ffd400', avatarInk: '#111111',
      dock: 'rgba(17,17,17,.95)', dockBorder: '2px solid #ffd400',
      font: 'Inter,sans-serif', headFont: 'Inter,sans-serif',
      radius: '16px', avatarRadius: '50%',
      faixa: 'ATENDIMENTO 24 HORAS', pesoTitulo: 900, ligarPrimeiro: true,
    },
  },
  {
    id: 'foto', nome: 'Foto Hero', nicho: 'Restaurante · hotel · imóveis',
    t: {
      bg: '#ffffff', ink: '#181818', sub: '#666666',
      accent: '#c0392b', onAccent: '#ffffff',
      card: '#f7f7f7', cardBorder: '1px solid #eeeeee',
      chip: '#f4f4f4', chipBorder: '1px solid #eeeeee',
      avatarBg: '#ffffff', avatarInk: '#c0392b',
      dock: 'rgba(255,255,255,.96)', dockBorder: '1px solid #eeeeee',
      font: 'Inter,sans-serif', headFont: 'Inter,sans-serif',
      radius: '16px', avatarRadius: '50%', heroFoto: true,
    },
  },
  {
    id: 'industrial', nome: 'Industrial', nicho: 'Oficina · construção · elétrica',
    t: {
      bg: '#1a1d21', ink: '#f2f3f4', sub: 'rgba(242,243,244,.7)',
      accent: '#f5852b', onAccent: '#1a1d21',
      card: '#24282e', cardBorder: '1px solid #363c45',
      chip: '#24282e', chipBorder: '1px solid #363c45', chipInk: '#ffb872',
      avatarBg: '#f5852b', avatarInk: '#1a1d21',
      dock: 'rgba(26,29,33,.95)', dockBorder: '1px solid #363c45',
      font: 'Inter,sans-serif', headFont: "'Bebas Neue',Inter,sans-serif",
      radius: '8px', avatarRadius: '14px', listra: true, tituloGrande: true,
    },
  },
  {
    id: 'natural', nome: 'Verde Natural', nicho: 'Pet · saúde · agro · jardim',
    t: {
      bg: '#f2f7f1', ink: '#1f3325', sub: '#5c7a64',
      accent: '#2f7d4f', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #d9e6dc',
      chip: '#ffffff', chipBorder: '1px solid #d9e6dc', chipInk: '#3f6b4c',
      avatarBg: '#ffffff', avatarInk: '#2f7d4f',
      dock: 'rgba(242,247,241,.95)', dockBorder: '1px solid #d9e6dc',
      font: "'Outfit',Inter,sans-serif", headFont: "'Outfit',Inter,sans-serif",
      radius: '16px', avatarRadius: '50%', sombraBtn: true,
      // faixa colorida no topo: o cabeçalho vira texto claro (senão fica ilegível)
      topoCurvo: 'linear-gradient(180deg,#2f7d4f,#4aa06a)', alturaTopo: 190,
      inkTopo: '#ffffff', subTopo: '#d7f0de',
    },
  },
  {
    id: 'solarpro', nome: 'Solar Premium', nicho: 'Energia solar · engenharia',
    t: {
      bg: '#0b1b2b', glow: 'radial-gradient(130% 80% at 50% 0,rgba(255,183,3,.28),transparent 70%)',
      ink: '#f2f7fb', sub: 'rgba(242,247,251,.72)',
      accent: '#ffb703', onAccent: '#0b1b2b',
      card: '#122740', cardBorder: '1px solid #1d3a5c',
      chip: '#122740', chipBorder: '1px solid #1d3a5c',
      avatarBg: 'linear-gradient(140deg,#ffb703,#ffd166)', avatarInk: '#0b1b2b',
      dock: 'rgba(11,27,43,.92)', dockBorder: '1px solid #1d3a5c',
      font: "'Manrope',Inter,sans-serif", headFont: "'Sora',Inter,sans-serif",
      radius: '14px', avatarRadius: '18px', pesoTitulo: 800, sombraBtn: '0 10px 24px rgba(255,183,3,.22)',
    },
  },
  {
    id: 'clinica', nome: 'Clínica Serena', nicho: 'Clínica · odonto · psicologia',
    t: {
      bg: '#f6fbfb', ink: '#12343b', sub: '#5b7c83',
      accent: '#0f9b8e', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #dceded',
      chip: '#eef7f7', chipBorder: '1px solid #dceded',
      avatarBg: '#ffffff', avatarInk: '#0f9b8e', avatarBorder: '4px solid #e3f2f1',
      dock: 'rgba(246,251,251,.95)', dockBorder: '1px solid #dceded',
      font: "'Manrope',Inter,sans-serif", headFont: "'Manrope',Inter,sans-serif",
      radius: '18px', avatarRadius: '50%', topoCurvo: '#e3f2f1',
    },
  },
  {
    id: 'fitness', nome: 'Alta Performance', nicho: 'Academia · crossfit · personal',
    t: {
      bg: '#0d0f12', glow: 'radial-gradient(120% 80% at 50% 0,rgba(198,255,0,.18),transparent 70%)',
      ink: '#ffffff', sub: 'rgba(255,255,255,.66)',
      accent: '#c6ff00', onAccent: '#0d0f12',
      card: '#16191e', cardBorder: '1px solid #262b33',
      chip: '#16191e', chipBorder: '1px solid #262b33',
      avatarBg: '#c6ff00', avatarInk: '#0d0f12',
      dock: 'rgba(13,15,18,.92)', dockBorder: '1px solid #262b33',
      font: "'Figtree',Inter,sans-serif", headFont: "'Anton',Impact,sans-serif",
      radius: '10px', avatarRadius: '12px', tituloGrande: true, pesoTitulo: 400,
    },
  },
  {
    id: 'boutique', nome: 'Boutique Editorial', nicho: 'Moda · boutique · decoração',
    t: {
      bg: '#f7f4ef', ink: '#1c1a17', sub: '#6f6659',
      accent: '#1c1a17', onAccent: '#f7f4ef',
      card: '#ffffff', cardBorder: '1px solid #e6e0d6',
      chip: '#ffffff', chipBorder: '1px solid #e6e0d6',
      avatarBg: '#ffffff', avatarInk: '#1c1a17', avatarBorder: '1px solid #e0d9cd',
      dock: 'rgba(247,244,239,.95)', dockBorder: '1px solid #e6e0d6',
      font: "'Work Sans',Inter,sans-serif", headFont: "'Cormorant Garamond',Georgia,serif",
      radius: '4px', avatarRadius: '2px', tituloGrande: true, capaTopo: true,
    },
  },
  {
    id: 'barber', nome: 'Barber Classic', nicho: 'Barbearia · tatuagem',
    t: {
      bg: '#171513', glow: 'radial-gradient(120% 90% at 50% 0,rgba(184,115,51,.3),transparent 72%)',
      ink: '#f3ece3', sub: 'rgba(243,236,227,.68)',
      accent: '#b87333', onAccent: '#171513',
      card: '#211e1b', cardBorder: '1px solid #3a342e',
      chip: '#211e1b', chipBorder: '1px solid #3a342e',
      avatarBg: 'linear-gradient(140deg,#b87333,#e0a668)', avatarInk: '#171513',
      dock: 'rgba(23,21,19,.92)', dockBorder: '1px solid #3a342e',
      font: "'Inter',sans-serif", headFont: "'Oswald',Impact,sans-serif",
      radius: '8px', avatarRadius: '50%', listra: 'rgba(184,115,51,.5)',
    },
  },
  {
    id: 'executivo', nome: 'Consultoria Executiva', nicho: 'Contabilidade · consultoria · seguros',
    t: {
      bg: '#ffffff', ink: '#0f1d33', sub: '#5a6b85',
      accent: '#14386b', onAccent: '#ffffff',
      card: '#f6f8fb', cardBorder: '1px solid #e3e8f0',
      chip: '#eef2f8', chipBorder: '1px solid #e3e8f0',
      avatarBg: '#eef2f8', avatarInk: '#14386b', avatarBorder: '1px solid #dbe3ee',
      dock: 'rgba(255,255,255,.96)', dockBorder: '1px solid #e3e8f0',
      font: "'Plus Jakarta Sans',Inter,sans-serif", headFont: "'Plus Jakarta Sans',Inter,sans-serif",
      radius: '10px', avatarRadius: '14px', pesoTitulo: 800,
    },
  },
  {
    id: 'festa', nome: 'Festa Confete', nicho: 'Festas · buffet · brinquedos',
    t: {
      bg: 'linear-gradient(165deg,#ff477e 0%,#ff7d3b 55%,#ffca3a 100%)',
      ink: '#ffffff', sub: 'rgba(255,255,255,.82)',
      accent: '#ffffff', onAccent: '#d92a63',
      card: 'rgba(255,255,255,.2)', cardBorder: '1px solid rgba(255,255,255,.34)',
      chip: 'rgba(255,255,255,.22)', chipBorder: '1px solid rgba(255,255,255,.3)',
      avatarBg: 'rgba(255,255,255,.26)', avatarInk: '#ffffff', avatarBorder: '3px solid rgba(255,255,255,.6)',
      dock: 'rgba(190,40,90,.55)', dockBorder: '1px solid rgba(255,255,255,.2)',
      font: "'Nunito',Inter,sans-serif", headFont: "'Poppins',Inter,sans-serif",
      radius: '20px', avatarRadius: '50%', glass: true, pesoTitulo: 800,
    },
  },
  {
    id: 'educacao', nome: 'Escola Clara', nicho: 'Escola · curso · idiomas',
    t: {
      bg: '#f4f8ff', ink: '#16243d', sub: '#5d6f8c',
      accent: '#2563eb', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #dde6f5',
      chip: '#e8f0fe', chipBorder: '1px solid #dde6f5',
      avatarBg: '#ffffff', avatarInk: '#2563eb', avatarBorder: '4px solid #e0eaff',
      dock: 'rgba(244,248,255,.95)', dockBorder: '1px solid #dde6f5',
      font: "'Nunito',Inter,sans-serif", headFont: "'Figtree',Inter,sans-serif",
      radius: '16px', avatarRadius: '50%', topoCurvo: '#e0eaff',
    },
  },
  {
    id: 'logistica', nome: 'Rota Segura', nicho: 'Transportadora · mudanças · frota',
    t: {
      bg: '#1a1d21', ink: '#f4f6f8', sub: 'rgba(244,246,248,.68)',
      accent: '#ff7a00', onAccent: '#1a1d21',
      card: '#24282e', cardBorder: '1px solid #343a42',
      chip: '#24282e', chipBorder: '1px solid #343a42',
      avatarBg: '#ff7a00', avatarInk: '#1a1d21',
      dock: 'rgba(26,29,33,.93)', dockBorder: '1px solid #343a42',
      font: "'Inter',sans-serif", headFont: "'Archivo Black',Impact,sans-serif",
      radius: '6px', avatarRadius: '8px', faixa: 'repeating-linear-gradient(135deg,#ff7a00 0 14px,#1a1d21 14px 28px)',
      pesoTitulo: 400,
    },
  },
  {
    id: 'marmore', nome: 'Mármore', nicho: 'Imóveis alto padrão · arquitetura',
    t: {
      bg: 'linear-gradient(170deg,#fbfaf8 0%,#efeae2 100%)',
      ink: '#22201d', sub: '#7a7268',
      accent: '#8a6a3f', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #e7e1d7',
      chip: '#f6f3ee', chipBorder: '1px solid #e7e1d7',
      avatarBg: '#ffffff', avatarInk: '#8a6a3f', avatarBorder: '1px solid #e0d8ca',
      dock: 'rgba(251,250,248,.95)', dockBorder: '1px solid #e7e1d7',
      font: "'Raleway',Inter,sans-serif", headFont: "'DM Serif Display',Georgia,serif",
      radius: '6px', avatarRadius: '50%', capaTopo: true, tituloGrande: true,
    },
  },
  {
    id: 'autocenter', nome: 'Auto Center', nicho: 'Oficina mecânica · troca de óleo · alinhamento',
    t: {
      bg: '#15171a', glow: 'radial-gradient(125% 85% at 50% 0,rgba(225,29,42,.26),transparent 72%)',
      ink: '#f6f7f9', sub: 'rgba(246,247,249,.68)',
      accent: '#e11d2a', onAccent: '#ffffff',
      card: '#1e2126', cardBorder: '1px solid #2e333a',
      chip: '#1e2126', chipBorder: '1px solid #2e333a',
      avatarBg: '#ffffff', avatarInk: '#15171a', avatarBorder: '3px solid #e11d2a',
      dock: 'rgba(21,23,26,.93)', dockBorder: '1px solid #2e333a',
      font: "'Inter',sans-serif", headFont: "'Oswald',Impact,sans-serif",
      radius: '8px', avatarRadius: '10px', pesoTitulo: 600,
      listra: 'rgba(225,29,42,.55)', sombraBtn: '0 10px 22px rgba(225,29,42,.28)',
      ligarPrimeiro: true,
    },
  },
  {
    id: 'autopecas', nome: 'Autopeças', nicho: 'Peças · baterias · acessórios automotivos',
    t: {
      bg: '#f4f6f9', ink: '#12233d', sub: '#5a6b82',
      accent: '#0b4ea2', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #dbe3ec',
      chip: '#fff8e1', chipBorder: '1px solid #f2dfa4', chipInk: '#7a5b00',
      avatarBg: '#ffffff', avatarInk: '#0b4ea2', avatarBorder: '3px solid #ffc31f',
      dock: 'rgba(244,246,249,.96)', dockBorder: '1px solid #dbe3ec',
      font: "'Inter',sans-serif", headFont: "'Archivo Black',Impact,sans-serif",
      radius: '8px', avatarRadius: '10px', pesoTitulo: 400,
      faixa: 'repeating-linear-gradient(135deg,#ffc31f 0 16px,#0b4ea2 16px 32px)',
    },
  },
  {
    id: 'showroom', nome: 'Showroom', nicho: 'Concessionária · stand de veículos',
    t: {
      bg: '#0e0f11', ink: '#ffffff', sub: 'rgba(255,255,255,.64)',
      accent: '#d8dee6', onAccent: '#0e0f11',
      card: '#171a1e', cardBorder: '1px solid #262a30',
      chip: '#171a1e', chipBorder: '1px solid #262a30',
      avatarBg: 'linear-gradient(140deg,#d8dee6,#8d949d)', avatarInk: '#0e0f11',
      dock: 'rgba(14,15,17,.94)', dockBorder: '1px solid #262a30',
      font: "'Inter',sans-serif", headFont: "'Sora',Inter,sans-serif",
      radius: '6px', avatarRadius: '6px', heroFoto: true, tituloGrande: true, pesoTitulo: 700,
    },
  },
  {
    id: 'construcao', nome: 'Depósito & Obra', nicho: 'Material de construção · tintas · elétrica',
    t: {
      bg: '#f7f7f5', ink: '#22252a', sub: '#5f646c',
      accent: '#f2a20c', onAccent: '#22252a',
      card: '#ffffff', cardBorder: '1px solid #e2e2de',
      chip: '#f0f0ec', chipBorder: '1px solid #e2e2de',
      avatarBg: '#22252a', avatarInk: '#f2a20c',
      dock: 'rgba(247,247,245,.96)', dockBorder: '1px solid #e2e2de',
      font: "'Inter',sans-serif", headFont: "'Rubik',Inter,sans-serif",
      radius: '6px', avatarRadius: '8px', pesoTitulo: 800,
      grade: 'linear-gradient(#e6e6e2 1px,transparent 1px) 0 0/100% 26px',
    },
  },
  {
    id: 'varejo', nome: 'Loja Viva', nicho: 'Loja · fornecedor · varejo em geral',
    t: {
      bg: '#ffffff', ink: '#1b1f24', sub: '#606a75',
      accent: '#e8590c', onAccent: '#ffffff',
      card: '#fbfbfc', cardBorder: '1px solid #e7e9ec',
      chip: '#fff1e8', chipBorder: '1px solid #ffd9c2', chipInk: '#a1400a',
      avatarBg: '#fff1e8', avatarInk: '#e8590c', avatarBorder: '1px solid #ffd9c2',
      dock: 'rgba(255,255,255,.96)', dockBorder: '1px solid #e7e9ec',
      font: "'DM Sans',Inter,sans-serif", headFont: "'Poppins',Inter,sans-serif",
      radius: '14px', avatarRadius: '16px', pesoTitulo: 700,
      sombraBtn: '0 8px 20px rgba(232,89,12,.22)',
    },
  },
  {
    id: 'farmacia', nome: 'Farmácia Confiança', nicho: 'Farmácia · drogaria · manipulação',
    t: {
      bg: '#f3faf6', ink: '#0f2e22', sub: '#547567',
      accent: '#0e8a5f', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #d7ece1',
      chip: '#e7f6ee', chipBorder: '1px solid #d7ece1',
      avatarBg: '#ffffff', avatarInk: '#0e8a5f', avatarBorder: '4px solid #e0f2e9',
      dock: 'rgba(243,250,246,.96)', dockBorder: '1px solid #d7ece1',
      font: "'Inter',sans-serif", headFont: "'Manrope',Inter,sans-serif",
      radius: '14px', avatarRadius: '50%', topoCurvo: '#e0f2e9', pesoTitulo: 800,
    },
  },
  {
    id: 'otica', nome: 'Ótica Precisão', nicho: 'Ótica · relojoaria · audiologia',
    t: {
      bg: '#fbfbfc', ink: '#15202e', sub: '#5c6a7a',
      accent: '#1b3a5c', onAccent: '#ffffff',
      card: '#ffffff', cardBorder: '1px solid #e4e7eb',
      chip: '#eef1f5', chipBorder: '1px solid #e4e7eb',
      avatarBg: '#ffffff', avatarInk: '#1b3a5c', avatarBorder: '1px solid #dde2e8',
      dock: 'rgba(251,251,252,.96)', dockBorder: '1px solid #e4e7eb',
      font: "'Manrope',Inter,sans-serif", headFont: "'Libre Baskerville',Georgia,serif",
      radius: '8px', avatarRadius: '50%', capaTopo: true,
    },
  },
  {
    id: 'imobiliaria', nome: 'Imobiliária Confiança', nicho: 'Imobiliária · corretor · arrendamento',
    t: {
      bg: '#ffffff', ink: '#10233c', sub: '#5a6c83',
      accent: '#0f6fb8', onAccent: '#ffffff',
      card: '#f7f9fc', cardBorder: '1px solid #e2e8f0',
      chip: '#eaf3fb', chipBorder: '1px solid #d7e6f3',
      avatarBg: '#eaf3fb', avatarInk: '#0f6fb8', avatarBorder: '1px solid #d7e6f3',
      dock: 'rgba(255,255,255,.96)', dockBorder: '1px solid #e2e8f0',
      font: "'Plus Jakarta Sans',Inter,sans-serif", headFont: "'Plus Jakarta Sans',Inter,sans-serif",
      radius: '12px', avatarRadius: '14px', capaTopo: true, pesoTitulo: 800,
    },
  },
];

export const getTemplate = (id) => TEMPLATES.find(t => t.id === id) || TEMPLATES[3]; // padrão: Clean Google

/** Sugere um modelo pela categoria do negócio (o cliente pode trocar depois). */
export function sugerirTemplate(categoria = '') {
  const c = categoria.toLowerCase();
  const regras = [
    // --- nichos com maior volume na base, do mais específico ao genérico ---
    [/peç|pec|autopeç|autopec|bateria|acessóri.*autom|acessori.*autom|pneu|som automotiv/, 'autopecas'],
    [/concessionár|concessionar|stand de autom|veículos usados|veiculos usados|revenda de carr|car dealer/, 'showroom'],
    [/oficina|mecânic|mecanic|troca de óleo|troca de oleo|alinhament|balanceament|funilar|auto center|auto elétric|auto eletric|retífic|retific/, 'autocenter'],
    [/materia(l|is).*constru|constru.*materia|building materials|tinta|elétric|eletric|hidrául|hidraul|ferramenta|tool store|serralh|marmorar|vidraçar|vidracar|madeir|telha|cimento/, 'construcao'],
    [/farmác|farmac|drogar|pharmacy|manipulaç/, 'farmacia'],
    [/ótica|otica|óptic|optic|relojoar|audiolog|aparelho auditiv/, 'otica'],
    [/imobiliár|imobiliar|corretor|arrendament|aluguel de imóve|real estate|loteament/, 'imobiliaria'],

    [/joia|joalher|advog|jurídic|estétic.*avanç|cirurg/, 'grafite'],
    [/padar|café|cafe|restaur|pizz|lanch|bar |confeit|doce/, 'terra'],
    [/celular|assistênc|assistenc|tecnolog|inform|games|eletrôn.*rep|computer repair|phone repair|electronics repair|cell phone/, 'neon'],
    [/salão|salao|cabelo|beleza|estétic|spa|manicure|sobrancelha|beauty salon|hair salon|nail salon|barber shop/, 'wellness'],
    [/chaveiro|desentup|guincho|24h|emergênc|urgent|reboqu/, 'urgencia'],
    [/hotel|pousada|turismo|resort|restaurant/, 'foto'],
    [/oficina|mecânic|mecanic|auto|construç|constru|elétric|eletric|hidrául|serralh/, 'industrial'],
    [/pet|veterin|animal|agro|jardin|paisag|planta|natural/, 'natural'],
    [/solar|fotovolta|energia|engenhar|placa.*solar/, 'solarpro'],
    [/clínic|clinic|odonto|dentist|psicólog|psicolog|fisioterap|médic|medic|laborat/, 'clinica'],
    [/academ|crossfit|personal|muscula|pilates|luta|jiu|treinam.*físic/, 'fitness'],
    [/moda|boutique|roupa|vestuár|vestuar|decoraç|decorac|móve|move|presente/, 'boutique'],
    [/barbear|barber|tatua|tattoo/, 'barber'],
    [/contabil|consultor|segur|financ|advocac.*empres|auditor|despachan|accounting|bookkeep|insurance|consulting|tax /, 'executivo'],
    [/festa|buffet|brinqued|evento|aniversár|aniversar|decoraç.*festa|som e luz/, 'festa'],
    [/escola|curso|idioma|creche|faculdad|reforço|reforco|educac|educaç/, 'educacao'],
    [/transport|mudanç|mudanc|frete|logíst|logist|frota|carret|caminh/, 'logistica'],
    [/alto padrão|alto padrao|arquitet|design de interior|incorporad/, 'marmore'],
    // genéricos: por último, senão engolem os nichos acima
    [/loja|fornecedor|distribuidor|comércio|comercio|atacad|varej|magazine|store|supplier/, 'varejo'],
  ];
  for (const [re, id] of regras) if (re.test(c)) return id;
  return 'clean';
}
